<script>
export default {
  name: 'NotFoundView'
}
</script>

<template>
  <section class="section is-hero">
    <div class="section-header has-text-centered">
      <div class="illustration">
        <img
          src="@/assets/img/illustrations/cherry-page-not-found.png"
          alt="Page not found"
        />
      </div>

      <hr class="spacer is-1" />
      <h1 class="title has-text-primary is-2 is-spaced">
        404: Page not found
      </h1>
      <h2 class="subtitle has-text-secondary is-4">
        We can't seem to find the page you're looking for.
      </h2>
      <hr class="spacer is-1" />
      <div class="buttons is-centered">
        <div class="rows">
          <div class="row">
            <a
              href="/dashboard"
              class="button is-rounded is-accent is-medium active"
            >
              Get back to dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="sass" scoped>
.section.is-hero
  margin-top: 5%

.illustration
  padding: 0 0 25px
  text-align: center
  img
    max-height: 200px
</style>
